module.exports = __webpack_public_path__ + "static/media/Scenario5Header.b8afbd71.jpg";